<template>
  <div>
    <el-table
      :row-style="{ height: '48px' }"
      :header-cell-style="{ background: '#f5f5f5', height: '48px' }"
      stripe
      :data="classeList"
      border
      style="width: 100%"
    >
      <el-table-column
        align="center"
        prop="title"
        label="班级名称"
        width="180"
      ></el-table-column>
      <el-table-column
        v-if="type == 8 ? true : false"
        align="center"
        prop="courseTypeName"
        label="课程类型"
      ></el-table-column>
      <el-table-column
        align="center"
        prop="headTeacherName"
        label="班主任姓名"
        width="180"
      ></el-table-column>
      <el-table-column
        align="center"
        prop="studentNums"
        label="已加入学生"
      ></el-table-column>
      <el-table-column
        align="center"
        prop="parentNums"
        label="已加入家长"
      ></el-table-column>
      <el-table-column label="操作" width="420" header-align="center">
        <template v-slot="scope">
          <el-button
            type="text"
            size="small"
            class="text_btn"
            @click="updateClasses(scope.row)"
            >编辑</el-button
          >
          <el-button type="text" v-if="!scope.row.headTeacherId" size="small" @click="addCharge(scope.row)"
            >设置班主任</el-button
          >
          <el-button
            type="text"
            v-show="scope.row.headTeacherId"
            size="small"
            @click="cancleTeacher(scope.row)"
            >取消班主任</el-button
          >
          <el-button
            type="text"
            v-if="type == 8 ? true : false"
            size="small"
             class="delete_btn"
            @click="graduation(scope,scope.row)"
            >毕业</el-button
          >
          <el-button
            size="small"
            type="text"
            class="delete_btn"
            v-if="
              totalPage === curPage && scope.$index == classeList.length - 1
            "
            @click="RemoveClass(scope.row)"
            >删除班级</el-button
          >
         
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页 -->
    <el-pagination
      background
      layout="prev, pager, next, jumper"
      :total="totalCount"
      :current-page="curPages"
      @current-change="currentChange"
    ></el-pagination>
    <!-- 添加班主任弹出框 -->
    <el-dialog
      title="设置班主任"
      class="tt_dialog"
      :visible.sync="dialogTableVisible"
      width="55%"
    >
      <el-form :inline="true" :model="teacher">
        <el-form-item label="姓名">
          <el-input v-model="teacher.name" size="small"></el-input>
        </el-form-item>
        <el-form-item label="手机号码">
          <el-input v-model="teacher.mobile" size="small"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" size="small" @click="teacherLists"
            >查询</el-button
          >
        </el-form-item>
      </el-form>
      <el-table
        :row-style="{ height: '48px' }"
        :header-cell-style="{ background: '#f5f5f5', height: '48px' }"
        :data="teachersList"
        stripe
      >
        <el-table-column
          property="name"
          align="center"
          label="教师姓名"
          width="300"
        ></el-table-column>
        <el-table-column
          property="mobile"
          align="center"
          label="教师手机号"
          width="300"
        ></el-table-column>
        <el-table-column label="操作" align="center">
          <template v-slot="scope">
            <el-button type="text" size="small" @click="addCharges(scope.row)"
              >设置为班主任</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页区域 -->
      <el-pagination
        background
        layout="total, prev, pager, next, jumper"
        @current-change="currentTeacherChange"
        :total="teacher.totalCount"
      ></el-pagination>
    </el-dialog>
    <!-- 编辑班级 -->
    <el-dialog title="编辑班级" :visible.sync="dialogClass" width="30%">
      <el-form ref="editClass" :model="classForm">
        <el-form-item
          label="班级名称"
          :label-width="formLabelWidth"
          prop="className"
          :rules="[
            { required: true, message: '请输入班级名称', trigger: 'blur' },
          ]"
        >
          <el-input
            v-model="classForm.className"
            style="width: 300px"
            autocomplete="off"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="课程类型"
          :label-width="formLabelWidth"
          prop="classType"
          :rules="[
            { required: true, message: '请选择课程类型', trigger: 'change' },
          ]"
        >
          <el-select
            v-model="classForm.classType"
            style="width: 300px"
            :disabled="classForm.studentNums !== 0"
            placeholder="请选择课程类型"
          >
            <el-option
              v-for="(item,index) in courseList"
              :label="item.typeName"
              :value="item.id"
              :key="index"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="dialogClass = false">取 消</el-button>
        <el-button size="small" type="primary" @click="editClass"
          >确 定</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  classesList,
  teacherLists,
  classSetTeacher,
  cancleTeacher,
  updateClasses,
  deleteClasses,
  selectEvaCourseType,
  setClassGraduated,
} from '@/api/home'
export default {
  data() {
    return {
      // 每页显示条数
      pageSize: 10,
      // 页码
      curPage: 1,
      // 数据总条数
      totalCount: 1,
      totalPage: 1,
      // 班级数据
      classeList: [],
      //   是否打开添加班主任弹出框
      dialogTableVisible: false,
      //   取消班主任是否隐藏
      headTeacher: true,
      // 教师
      teacher: {
        // 页码
        curPage: 1,
        // 每页显示条数
        pageSize: 10,
        // 数据总条数
        totalCount: 1,
        // 姓名
        name: '',
        // 手机号
        mobile: '',
      },
      //   教师列表
      teachersList: [],
      className: '',
      //   班级ID
      classID: 0,
      //   教师ID
      teacherID: 0,
      type: '',
      typeTime:'',
      schoolId: localStorage.getItem('schoolIds'),
      classForm: {
        className: '',
        classType: '',
      },
      formLabelWidth: '120px',
      dialogClass: false,
      courseList: [],
      row: {},
      courseTypeName: '',
    }
  },
  // 接受父组件传值
  props: {
    gradeId: {
      type: String,
      //   default: 7,
      required: true,
      // totalCount: 1,
    },
    curPages: {
      type: Number,
      default: 1,
    },
  },
  created() {
    this.classesList()
    this.selectEvaCourseType()
    this.type = localStorage.getItem('type')
    // this.typeTime = setInterval(() => {
    //   this.type = localStorage.getItem('type')
    //   this.selectType()
    // }, 500);
  },
  watch: {
    gradeId: function (val, oldVal) {
      this.classesList()
    },
  },
  methods: {
    // selectType(){
    //   if (this.type !== null) {
    //     clearInterval(this.typeTime)
    //   }
    // },
    //   获取班级列表
    async classesList() {
      //   var gradeId = parseInt(this.gradeId)
      // console.log(this.curPages);
      try {
        const { data: res } = await classesList({
          schoolId: this.schoolId,
          curPage: this.curPages,
          pageSize: this.pageSize,
          gradeId: this.gradeId,
        })
        this.classeList = res.data.dataList
        this.totalCount = res.data.totalCount
        this.totalPage =
          res.data.totalCount % 10 == 0
            ? res.data.totalCount / 10
            : parseInt(res.data.totalCount / 10) + 1
      } catch (err) {
        console.log(err)
      }
    },
    // 获取教师列表
    async teacherLists() {
      try {
        const { data: res } = await teacherLists({
          curPage: this.teacher.curPage,
          schoolId: this.schoolId,
          name: this.teacher.name,
          mobile: this.teacher.mobile,
          pageSize: this.teacher.pageSize,
        })
        // console.log(res.data)
        this.teachersList = res.data.dataList
        this.teacher.totalCount = res.data.totalCount
      } catch (err) {}
    },

    // 获得班级ID
    addCharge(item) {
      this.dialogTableVisible = true
      this.classID = item.id
      this.className = item.title
      this.teacherLists()
    },
    // 取消班主任
    async cancleTeacher(row) {
      this.$confirm(
        `您确定要解除<span style="color:#409EFF;margin:0 10px;"> ${
          row.title + ' ' + row.headTeacherName
        } </span>班主任的身份吗？`,
        '提示',
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
          dangerouslyUseHTMLString: true,
        }
      )
        .then(() => {
          cancleTeacher({
            classesId: row.id,
          }).then(() => {
            this.$message({
              type: 'success',
              message: '删除成功',
            })
            this.classesList()
          })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除',
          })
        })
    },
    // 页码变化时，触发classList函数
    currentChange(e) {
      this.curPages = e
      this.curPage = e
      this.classesList()
    },

    currentTeacherChange(e) {
      this.teacher.curPage = e
      this.teacherLists()
    },

    // 设置班级班主任
    async classSetTeacher() {
      try {
        const { data: res } = await classSetTeacher({
          classesId: this.classID,
          teacherId: this.teacherID,
        })
        this.$message.success(res.msg)
      } catch (err) {
        console.log(err)
      }
      //   调用班级列表接口
      this.classesList()
    },
    // 获取教师ID，并设置班主任
    async addCharges(row) {
      this.teacherID = row.id
      // 调用设置班主任接口

      this.$confirm(
        `您确定要设置<span style="color:#409EFF;margin:0 10px;"> ${
          row.name + '为' + this.className
        } </span>为班主任的吗？`,
        '提示',
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
          dangerouslyUseHTMLString: true,
        }
      )
        .then(() => {
          cancleTeacher({
            classesId: row.id,
          }).then(() => {
            this.classSetTeacher()
            // this.$message({
            //   type: 'success',
            //   message: '设置成功',
            // })
            this.dialogTableVisible = false
          })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消设置',
          })
        })
    },

    // 修改班级名称
    updateClasses(row) {
      this.row = row
      if (this.type == 8) {
        this.classForm.className = row.title
        this.classForm.classType = row.courseTypeId
        this.classForm.studentNums = row.studentNums
        this.dialogClass = true
        // this.selectEvaCourseType()

        return false
      }
      this.$prompt('请输入班级名称', '修改班级名称', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        inputPattern: /\S/,
        inputErrorMessage: '班级名称不能为空',
        inputPlaceholder: row.title,
      })
        .then(({ value }) => {
          this.classForm.className = value
          this.updateClassesName()
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '取消输入',
          })
        })
    },
    //删除班级
    RemoveClass(item) {
      this.$confirm('是否要删除该班级', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          this.ApiDelete(item)
          
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除',
          })
        })
    },
    // 毕业班级
    graduation(scope,row) {
      console.log(scope);
      this.$confirm('该班级需要毕业吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          setClassGraduated({
            classId: row.id,
          }).then(res=>{
            this.classesList()
          })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '取消操作',
          })
        })
    },
    editClass() {
      this.$refs.editClass.validate((valid) => {
        if (valid) {
          // alert('submit!')
          this.courseList.forEach((item) => {
            if (this.classForm.classType == item.id) {
              this.courseTypeName = item.typeName
            }
          })
          this.updateClassesName()
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    // 修改班级
    updateClassesName() {
      updateClasses({
        courseTypeId: this.classForm.classType,
        courseTypeName: this.courseTypeName,
        schoolId: this.row.schoolId,
        gradeNum: this.row.gradeNum,
        num: this.row.num,
        gradeId: this.row.gradeNum,
        id: this.row.id, //班级ID
        title: this.classForm.className, //班级名称
      }).then((res) => {
        this.$message({
          type: 'success',
          message: '修改成功',
        })
        // this.$refs.editClass.resetFields()
        this.dialogClass = false
        
        this.classesList()
      })
    },
    // 删除班级
    async ApiDelete(item) {
      const { data: res } = await deleteClasses(item.id)
      this.$emit('removeClass','')
      this.classesList()
    },
    // 获取课程类型列表
    async selectEvaCourseType() {
      const { data: res } = await selectEvaCourseType()
      this.courseList = res.data
    },
  },
}
</script>
<style scoped>
/* .el-form-item {
  width: 260px;
  float: left;
} */
.el-input {
  width: 100%;
}
.el-button + .el-button {
  margin-left: 20px;
}
.text_btn {
  margin-left: 30px;
}
</style>


// WEBPACK FOOTER //
// src/views/school/components/components/ClassesTable.vue